export const setupCopyEnUs = {
    yourHospitalNumber: "Your hospital number",
    hospitalNumberIntro:
        "Your hospital number helps identify you in the hospital system. If your clinician has assigned you a number, please enter it here.",
    hospitalNumberFieldHint: "This helps identify you in the hospital system.",
    dontKnow: "I don't know",
    skipForNow: "I don't know yet",
    whichSideAffectedTitle: "Which side of your body is affected?",
    sideSetupLeadInTrackersOnly:
        "We need to know which side of your body is affected so we can ask you the right questions for the following questionnaires: ",
    sideSetupLeadInProceduresOnly: "We need to know which side of your body is affected so we can line this up with: ",
    sideSetupLeadInBoth:
        "We need to know which side of your body is affected so we can ask you the right questions for the following questionnaires and your treatment: ",
    sideSetupBothSidesNote: "If both sides are affected, choose Both and we will add a questionnaire for each side.",
    saveDate: "Save date",
    pickDate: "Pick a date",
    clearDateAndTime: "Clear Date and Time",
    missingReferenceDateDataError:
        "Unable to save procedure date - missing data identifiers. Please try refreshing the page or contact support if this continues.",
    referenceDateMinMessage: "Choose a date no more than 2 years in the past.",
    referenceDateMaxMessage: "Choose a date no more than 2 years in the future.",
    referenceDateQuestion: (kind) => {
        if (kind === "product") return "What date did or will you start using the product?";
        if (kind === "injection") return "What date did or will you have the injection?";
        if (kind === "surgery") return "What date did or will you have the surgery?";
        if (kind === "medication") return "What date did or will you start the medication?";
        if (kind === "shockwave") return "What date did or will you start the shockwave therapy?";
        if (kind === "consultation") return "What date did or will you have the consultation?";
        return "What date did or will you have the procedure?";
    },
    referenceDateDescriptionFor: (phrase, kind) => {
        if (kind === "product") {
            return `Choose when you started using ${phrase} - past or upcoming - so your follow-up questions line up with it.`;
        }
        if (kind === "injection") {
            return `Choose the date of your injection - past or upcoming - so your follow-up questions line up with it.`;
        }
        if (kind === "shockwave") {
            return `Choose the date of your shockwave therapy - past or upcoming - so your follow-up questions line up with it.`;
        }
        if (kind === "surgery") {
            return `Choose the date of your ${phrase} - past or upcoming - so your follow-up questions line up with it.`;
        }
        if (kind === "consultation") {
            return `Choose the date of your consultation - past or upcoming - so your follow-up questions line up with it.`;
        }
        return `Choose the date of your ${phrase} - past or upcoming - so your follow-up questions line up with it.`;
    },
    productStartDateLabel: (phrase) => `Date you started ${phrase}`,
    chooseDateError: (phrase) => `Please choose the date of your ${phrase}`,
    chooseProductStartDateError: (phrase) => `Please choose when you started using ${phrase}`,
    savedProcedureDateToast: (phrase) => `Your ${phrase} date has been saved.`,
    savedProductStartDateToast: (phrase) => `Your ${phrase} start date has been saved.`,
};
